
import axios from "axios";
import { BASE_URL } from "../constants";
import getHeaders from "../constants/headers";

export const createJobProcess = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "api/secure/v1/customer-job-process",
    data: JSON.stringify(data),
    headers: getHeaders(),
  });
};

export const getJobProcess = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "api/secure/v2/customer-job-process",
    data: JSON.stringify(data),
    headers: getHeaders(),
  });
};

export const getJobProcessList = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "api/secure/user/v1/job-process-list",
    data: JSON.stringify(data),
    headers: getHeaders(),
  });
};

export const updateJobProcess = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "api/secure/v1/customer-job-process",
    data: JSON.stringify(data),
    headers: getHeaders(),
  });
};


